import {Link} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

export const InvoicesNotice = () => {
  const {user} = useCurrentUserContext();

  return (
    <p className="text-gray-700">
      New invoices are available two hours after payment is made.{" "}
      {user?.has_admin_access ? (
        <>
          You can designate <Link to="/accounts/user-management">users</Link> to receive invoices via Email.
        </>
      ) : (
        <>
          Subscribe to receive invoices on your{" "}
          <Link to={`${URL_ORIGINAL_WEBSITE}/accounts/profile`}>User Profile</Link> form.
        </>
      )}{" "}
      {user?.has_admin_access && (
        <>
          To edit billing information that appears on your invoices, click{" "}
          <Link to={"/accounts/account-details"}>here</Link>.
        </>
      )}
    </p>
  );
};
